import { i18n } from '@lingui/core'
import { t } from '@lingui/macro'
import { StyleSheet, Text, View } from '@react-pdf/renderer'
import { getLabelFromTranslationData } from 'app/views/common/translationsCommon'
import { PdfSplittableTableRow } from 'app/views/forms/pdf-components/PdfSplittableTableRow'
import { PdfTableCell } from 'app/views/forms/pdf-components/PdfTableCell'
import { PdfTableHeaderCell } from 'app/views/forms/pdf-components/PdfTableHeaderCell'
import { pdfTableStyles } from 'app/views/forms/pdf-components/PdfTableStyles'
import { PdfUnsplittableTableRow } from 'app/views/forms/pdf-components/PdfUnsplittableTableRow'
import React from 'react'

const styles = StyleSheet.create({
  nameCol: {
    width: '35%'
  },
  emailCol: {
    width: '30%'
  },
  roleCol: {
    width: '35%'
  }
})

interface AffiliationRole {
  apiValue?: string
  label?: Record<string, string>
}

interface Affiliation {
  name?: string
  email?: string
  /** API value of one of the configured roles */
  role?: string
}

interface FormProjectAffiliationsPdfTypeProps {
  roles?: AffiliationRole[]
}

interface FormProjectAffiliationsPdfProps {
  typeProps?: FormProjectAffiliationsPdfTypeProps
  value?: Affiliation[]
  langVersion: string
}

export const FormProjectAffiliationsPdf = ({
  typeProps = {},
  value = [],
  langVersion
}: FormProjectAffiliationsPdfProps): React.ReactElement => {
  const { roles = [] } = typeProps

  const getRoleLabel = (role?: string): string => {
    const config = roles.find((item) => item.apiValue && item.apiValue === role)
    return config?.label ? getLabelFromTranslationData({ data: config.label, langVersion }) : ''
  }

  return (
    <View style={pdfTableStyles.table}>
      <PdfUnsplittableTableRow>
        <PdfTableHeaderCell style={styles.nameCol}>{i18n._(t`Contact name`)}</PdfTableHeaderCell>
        <PdfTableHeaderCell style={styles.emailCol}>{i18n._(t`Contact e-mail`)}</PdfTableHeaderCell>
        <PdfTableHeaderCell style={styles.roleCol}>{i18n._(t`Contact role`)}</PdfTableHeaderCell>
      </PdfUnsplittableTableRow>

      {value.map((contact, index) => (
        <PdfSplittableTableRow key={index}>
          <PdfTableCell style={styles.nameCol}>
            <Text>{contact.name}</Text>
          </PdfTableCell>
          <PdfTableCell style={styles.emailCol}>
            <Text>{contact.email}</Text>
          </PdfTableCell>
          <PdfTableCell style={styles.roleCol}>
            <Text>{getRoleLabel(contact.role)}</Text>
          </PdfTableCell>
        </PdfSplittableTableRow>
      ))}
    </View>
  )
}
